<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef" :select-list.sync="selectList">
      <template slot="searchBar">
        <el-form-item label="设备型号">
          <el-input v-model.trim="tableData.search.model" clearable></el-input>
        </el-form-item>
        <el-form-item label="SN">
          <el-input v-model.trim="tableData.search.sn" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="operateBar">
        <el-button-group>
          <el-button v-if="checkApi('importFormal')" size="small" type="primary" @click="add">导入授权</el-button>
          <el-button v-if="checkApi('reviseFormal')" size="small" type="primary" @click="reviseBatch" :disabled="!selectList.length">批量修改</el-button>
          <el-button v-if="checkApi('deleteFormal')" size="small" type="primary" @click="removeBatch" :disabled="!selectList.length">批量删除</el-button>
        </el-button-group>
      </template>
      <template v-if="hasApi(['reviseFormal','deleteFormal','downloadFormalKey'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="160">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('downloadFormalKey')" type="text" @click="downloadKey(row)">下载KEY</el-button>
            <el-button v-if="checkApi('reviseFormal')" type="text" @click="revise(row)">修改</el-button>
            <el-button v-if="checkApi('deleteFormal')" type="text" class="danger" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <import-formal v-if="importFormal.visible" :dialog-data="importFormal" @table-reload="getTableList"/>
  </div>
</template>

<script>
  import ImportFormal from "./dialog/ImportFormal"
  export default {
    name: "formalManage",
    components: {ImportFormal},
    data() {
      return {
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "设备型号", property: "model"},
            {label: "SN", property: "sn", width: 200},
            {label: "使用时间", property: "buy_at"},
            {label: "激活时间", property: "active_at"},
            {label: "授权到期时间", property: "expire_at"},
            {label: "导入时间", property: "create_at"},
            {label: "备注", property: "remark"},
            {label: "创建人", property: "admin.name"},
          ],
          api: "getAuthFormal",
          isMultiple: true,
          search: {
            model: "",
            sn: "",
          }
        },
        countList: [{name: "总记录", count: 0}],
        selectList: [],
        importFormal: {visible: false, width: 500, title: "", row: null, isBatch: false},
      }
    },
    methods: {
      async downloadKey(row) {
        const nv = {auth_prod_id: row.id}
        const blob = await this.$Http.downloadFormalKey(nv, {responseType: "blob"});
        if (blob) {
          this.downloadFile(blob.name, blob);
        }
      },
      add() {
        this.importFormal.visible = true;
        this.importFormal.title = "导入授权";
        this.importFormal.row = null;
        this.importFormal.isBatch = false;
      },
      revise(row) {
        this.importFormal.visible = true;
        this.importFormal.title = "修改授权";
        this.importFormal.row = row;
        this.importFormal.isBatch = false;
      },
      reviseBatch() {
        this.importFormal.visible = true;
        this.importFormal.title = "批量修改授权";
        this.importFormal.isBatch = true;
        this.importFormal.row = {
          id: this.selectList.map(item => item.id),
          expire_at: "",
          remark: "",
        };
      },
      remove(row) {
        this.openConfirm("删除该授权码", async () => {
          let nv = {auth_prod_id: row.id};
          let res = await this.$Http.deleteFormal(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.getTableList();
          }
        });
      },
      removeBatch() {
        let length = this.selectList.length;
        this.openConfirm(`批量删除选中的 ${length} 个授权码`, async () => {
          let nv = {auth_prod_id: this.selectList.map(item => item.id)};
          let res = await this.$Http.deleteFormal(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.getTableList();
          }
        });
      },
      getTableList() {
        this.$refs["tableRef"].refresh();
      },
    },
  }
</script>

<style scoped>

</style>
